/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Send_MessageInputs */

const en_send_message = /** @type {(inputs: Send_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a Message`)
};

const es_send_message = /** @type {(inputs: Send_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar un Mensaje`)
};

const fr_send_message = /** @type {(inputs: Send_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer un message`)
};

const de_send_message = /** @type {(inputs: Send_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht senden`)
};

const id_send_message = /** @type {(inputs: Send_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim Pesan`)
};

/** @type {(inputs: Send_MessageInputs) => LocalizedString} */
const ja_send_message = en_send_message;

/** @type {(inputs: Send_MessageInputs) => LocalizedString} */
const zh_send_message = en_send_message;

/** @type {(inputs: Send_MessageInputs) => LocalizedString} */
const ar_send_message = en_send_message;

/** @type {(inputs: Send_MessageInputs) => LocalizedString} */
const it_send_message = en_send_message;

/** @type {(inputs: Send_MessageInputs) => LocalizedString} */
const ru_send_message = en_send_message;

/** @type {(inputs: Send_MessageInputs) => LocalizedString} */
const pt_send_message = en_send_message;

/** @type {(inputs: Send_MessageInputs) => LocalizedString} */
const ko_send_message = en_send_message;

/**
* | output |
* | --- |
* | "Send a Message" |
*
* @param {Send_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const send_message = /** @type {((inputs?: Send_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Send_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_send_message(inputs)
	if (locale === "es") return es_send_message(inputs)
	if (locale === "fr") return fr_send_message(inputs)
	if (locale === "de") return de_send_message(inputs)
	if (locale === "ja") return ja_send_message(inputs)
	if (locale === "zh") return zh_send_message(inputs)
	if (locale === "ar") return ar_send_message(inputs)
	if (locale === "id") return id_send_message(inputs)
	if (locale === "it") return it_send_message(inputs)
	if (locale === "ru") return ru_send_message(inputs)
	if (locale === "pt") return pt_send_message(inputs)
	return ko_send_message(inputs)
});